import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const fetchProducts = async () => {
  const { data } = await axios.get(`${API}/products`);
  return data;
};

export const fetchProduct = async (slug) => {
  const { data } = await axios.get(`${API}/products/${slug}`);
  return data;
};

export const createOrder = async (payload) => {
  const { data } = await axios.post(`${API}/orders`, payload);
  return data;
};

export const fetchOrder = async (orderNumber) => {
  const { data } = await axios.get(`${API}/orders/${orderNumber}`);
  return data;
};

export const subscribe = async (email) => {
  const { data } = await axios.post(`${API}/subscribe`, { email });
  return data;
};
